import { withStylePrefix } from '../common/withStylePrefix';
import { TilesComponent, tilesTemplate } from './Tiles';
import styles from './Tiles.styles.scss';
export const tilesDefinition = {
    baseName: 'tiles',
    template: tilesTemplate,
    styles: withStylePrefix(styles),
};
export const chameleonTiles = TilesComponent.compose(tilesDefinition);
